import React, { useEffect, useState } from "react";
import { Transition, Dialog } from "@headlessui/react";
import Button from "../Button";
import { useAuth } from "../../util/auth";
import { handleEmail } from "../../util/email";
import { Link } from "../../util/router";

function StateFarmCheckModal(props) {
  // TEMPORARILY DISABLED - T-019: Email update flow is broken (no verification)
  // Re-enable after verifyBeforeUpdateEmail() is implemented
  // See .dev/Context/T-019/Bug_Report.md for details
  return null;

  const auth = useAuth();
  const [visible, setVisible] = useState(false)

  useEffect(() => {
    async function checkEmail() {
      let res = await handleEmail("checkStateFarm", {
        email: auth.user?.email,
      })
      setVisible(!res?.success)
    }

    if (auth.user?.email) {
      checkEmail();
    }
  }, [auth.user?.email]);


  const handleSubmit = (e) => {
    e.preventDefault();
    console.log(e)
  };
  return (
    <Transition appear={true} show={visible}>
      <Dialog
        as="div"
        className="overflow-y-auto fixed inset-0 z-10"
        onClose={() => props.onDone()}
      >
        <div className="px-4 min-h-screen text-center">
          <Transition.Child
            as={React.Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <Dialog.Overlay className="fixed inset-0 bg-gray-500 bg-opacity-75" />
          </Transition.Child>
          <span
            className="inline-block h-screen align-middle"
            aria-hidden="true"
          >
            &#8203;
          </span>
          <Transition.Child
            as={React.Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <div className="inline-block overflow-hidden p-6 my-8 w-full max-w-xl text-left align-middle bg-white rounded-2xl shadow-xl transition-all transform">
              <Dialog.Title
                className="text-xl font-bold leading-6 text-gray-900"
              >
                Update Your Email to Restore Full Access.
              </Dialog.Title>
              <Dialog.Description
                as="div"
                className="text-base text-gray-700 space-y-4"
              >
                <p className="text-lg font-semibold text-gray-800">
                  To unlock all features, please follow these simple steps:
                </p>
                <ol className="list-decimal list-inside space-y-2 pl-4">
                  <li>Click the button below to go to your <span className="font-semibold">Account Settings</span>.</li>
                  <li>On the next page, click the <span className="font-semibold">"Edit Information"</span> button.</li>
                  <li>Type your new personal email into the email field and save.</li>
                </ol>
              </Dialog.Description>
              <div className="mt-4">
                <form className="space-y-4" onSubmit={handleSubmit}>
                  <div className="space-x-2 flex items-stretch">
                    <Button
                      component={Link}
                      to="/settings/account"
                      size="xl"
                    >
                      Go to Settings to Update Email
                    </Button>
                  </div>
                </form>
              </div>
            </div>
          </Transition.Child>
        </div>
      </Dialog>
    </Transition>
  );
}

export default StateFarmCheckModal;
